
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompareTableComponent } from './compare-table.component';
import { AnimatedHandModule } from '@app/shared/ui/animated-hand/animated-hand.module';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { FloatingArrowModule } from '../floating-arrow/floating-arrow.module';

@NgModule({
    imports: [
        CommonModule,
        AnimatedHandModule,
        LazyLoadImageModule,
        FloatingArrowModule
    ],
    exports: [
        CompareTableComponent,
    ],
    declarations: [
        CompareTableComponent
    ],
    providers: []
})
export class CompareTableModule {
}
